// Notifies via the callback function the first time a provider comes into the viewport, lazy loading IntersectionObserver
// as needed.
export const providerInView = (providerEl, callback) => {
    if (typeof window.IntersectionObserver === 'function') {
        // eslint-disable-next-line compat/compat
        const observer = new window.IntersectionObserver((providerEntryArray) => {
            const providerEntry = providerEntryArray[0];
            if (providerEntry.intersectionRatio > 0) {
                observer.unobserve(providerEl);
                callback(providerEntry);
            }
        }, { threshold: 0.8 });
        observer.observe(providerEl);
    }
    return Promise.resolve();
};
